module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'erfolg',
    selected: 'Ausgewählt',
    chooseGiftFirst: 'Bitte wählen Sie zuerst eine Geschenkkarte: Apple oder Starbucks.',
    综合评价: "Gesamtbewertung",
    inputNotSame: "Eingabe Nicht Gleich",
    example: 'Beispiel',

    "btnPrev": "Zurück",
    // 选择语言
    popupTitle: 'Sprache auswählen',
    // 发送
    send: 'Bestätigen',
    // 发送邮件
    sendEmail: 'E-Mail senden',
    // 改变语言
    changeLanSes: 'Sprachwechsel erfolgreich',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'Stimme des Käufers',
    // 系统解释
    details: 'Wir hören auf die Stimmen unserer Käufer und bieten hochwertige Produkte und Dienstleistungen.\nVielen Dank, dass Sie bei uns sind!',
    fileSizeOver: "Datei ist zu groß, es werden nur Bilder unter 10MB unterstützt.",
    lowTextarea: 'Ihr Feedback wird uns helfen, unsere Produkte und Dienstleistungen kontinuierlich zu verbessern.',
    placeholderOrderNo: "Bitte geben Sie die Bestellnummer ein (Format: 000-0000000-0000000)",
    "picUploadSuccessText": "Bild erfolgreich hochgeladen",
    "picUploadErrorText": "Bild-Upload fehlgeschlagen",
    "orderNotExistText": "Die Bestellung existiert nicht",
    "orderInvalidText": "Diese Bestellung ist ungültig",
    "networkErrorText": "Netzwerkfehler",
    "orderErrorText": "Bestellfehler",
    // step1
    formBasic: {
        confirm_btn: "Bestätigen",
        "order_help_title": "Hilfe zur Bestellnummer",
    "order_help_content": "Wenn Sie Ihre Bestellnummer nicht kennen, kontaktieren Sie uns bitte, um zu erfahren, wie Sie diese erhalten können. Unsere E-Mail: ",
        form_code: 'Verifizierungscode',
        form_code_placeholder: 'Bitte geben Sie den Verifizierungscode ein',
        "get_code": "Code abrufen",
  "code_sent_success": "Code erfolgreich gesendet",
        "platform_name": "Plattformname",
        "platform_name_placeholder": "Bitte wählen Sie eine Plattform",
  "form_name_placeholder": "Bitte geben Sie Ihren Namen ein",
        title: 'Registrieren Sie Ihre Garantie und<br><span style="color:#C9A127">fordern Sie Ihr Mystery-Geschenk an</span>',
        form_name: 'Name',
        form_email: 'E-Mail',
        form_email_note: 'für den Geschenkversand und den Support',
        form_order: 'Bestellnummer',
        form_order_error_placeholder: 'Bitte geben Sie die Bestellnummer ein (Format: 000-0000000-0000000)',
        order_why: '*Wie finden Sie Ihre Bestellnummer?',
        order_answer: `*Wir geben Ihre persönlichen Daten nicht an Dritte weiter.`,
        btn_text: 'Jetzt freischalten',
        "form_name_placeholder": "Bitte geben Sie Ihren Namen ein",
        "form_email_placeholder": "Bitte geben Sie Ihre E-Mail-Adresse ein",
        "form_email_error_placeholder": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "form_order_placeholder": "Bitte geben Sie Ihre Bestellnummer ein"
    },
    // step2
    showGiftCard: {
        title: 'Ihre erweiterte Garantie ist aktiviert.<br>Wir haben Ihrem Produkt <strong>9 Monate</strong> Garantie hinzugefügt.<br>Vielen Dank für Ihren Kauf!',
        text: '🎁 Holen Sie sich Ihre 20-$-Geschenkkarte und teilen Sie Ihre Erfahrung<br><small>(Dauert weniger als 1 Minute)</small>',
        gift_card_text: 'Wählen Sie Ihre 20-$-E-Geschenkkarte',
        btn_text: 'Meine Prämie erhalten'
    },
    // step3
    expectations: {
        title: "Vielen Dank, dass Sie sich für unsere Produkte und Dienstleistungen entschieden haben!",
        text: "Wenn es Ihre Erwartungen erfüllt oder Sie positiv überrascht, nehmen Sie sich doch ein paar Sekunden Zeit, um eine positive Bewertung auf der Verkaufsseite abzugeben. Hinterlassen Sie eine positive Bewertung und erhalten Sie eine 10-$-Geschenkkarte!",
        btn_text: "Nächster Schritt"
    },
    // step3
    star: {
        title: 'Sind Sie mit diesem Produkt oder unserem Service zufrieden?',
        text: 'Bitte vergeben Sie eine Sternebewertung für das Produkt unten:',
        star__placeholder: 'Bitte bewerten Sie alle Fragen, bevor Sie absenden!',
        written: 'Schreiben Sie eine Bewertung: <span style="color:#F40000">(Optional)</span>',
        written_placeholder: 'Was hat Ihnen gefallen? Wofür haben Sie dieses Produkt verwendet?',
        btn_text: 'Nächster Schritt'
    },
    // step4
    ensureEmail: {
        title: `Herzlichen Glückwunsch!</br>
Sie haben die Umfrage beendet.
`,
        text: `Bitte bestätigen Sie die E-Mail-Adresse, Sie werden den Geschenkcode über diese E-Mail-Adresse erhalten:
customerservice8@yeah.net`,
        email_placeholder: 'Bitte bestätigen Sie die E-Mail erneut!',
        btn_text: 'Bestätigen Sie'
    },
    // step5
    reviewGuide: {
        title: 'So hinterlassen Sie eine Bewertung auf Ihrer Einkaufsplattform',
        subtitle: 'Wählen Sie Ihre Plattform, um die Schritte zu sehen.'
    },
    channelSelect: {
        title: `Ihr Feedback ist wichtig! `,
        text: "Vielen Dank für Ihr wertvolles Feedback! Jetzt können Sie das gewünschte Geschenk auswählen!!!",
        footer: `*Über das Geschenk:</br>
Keine Versandgebühren, keine versteckten Gebühren, keine Kreditkarte erforderlich`,
        btn_text: 'Ich will es'
    },
    // step6
    uploadPic: {
        guideText: 'Brauchen Sie Hilfe beim Erstellen des Screenshots?<br><small>Wählen Sie unten Ihre Einkaufsplattform für eine kurze Anleitung.</small>',
       "title": "Bitte laden Sie einen Screenshot Ihrer Produkterfahrung hoch.",
  "text": "Um Ihre 20-$-Geschenkkarte zu erhalten, reichen Sie einfach unten einen Screenshot<br>Ihrer veröffentlichten Bewertung ein.",
        add_pic: 'Klicken oder Datei hierher ziehen',
        add_pic_text: 'JPG / PNG, bis zu 10 MB',
        btn_text: 'Absenden & Geschenk erhalten',
        uploading: 'Hochladen... Bitte warten',
        upload_required: 'Bitte laden Sie zuerst einen Screenshot hoch, bevor Sie fortfahren.',
        "no_file_selected": "Keine Datei ausgewählt"
    },
    // step7
    cityForm: {
        title: '*Zubehör Empfangsadresse: ',
        text: '(Bitte bestätigen Sie Ihre Lieferadresse, das kostenlose Geschenk wird innerhalb von 3-5 Arbeitstagen zugestellt).',
        form_city: 'Stadt',
        form_state: 'Bundesland/Region',
        form_postal_code: 'Postleitzahl',
        form_country: 'Land',
        btn_text: 'Bestätigen Sie',
        "form_city_placeholder": "Bitte geben Sie Ihre Stadt ein",
        "form_state_placeholder": "Bitte geben Sie Ihr Gebiet ein",
        "form_postal_code_placeholder": "Bitte geben Sie Ihre Postleitzahl ein",
        "form_country_placeholder": "Bitte geben Sie Ihr Land ein"
    },
    // step7
    paypalForm: {
        title: 'Wohin sollen wir Ihre 20-$-Geschenkkarte senden?',
        text: '(Bitte stellen Sie sicher, dass Ihre PayPal-Daten korrekt sind, um Verzögerungen zu vermeiden.)',
        form_paypal: 'PayPal-Konto',
        form_ensure_paypal: 'PayPal-Konto bestätigen',
        form_paypal_name: 'Name des PayPal-Kontos',
        btn_text: 'Bestätigen Sie',
        "form_paypal_placeholder": "Bitte geben Sie Ihr PayPal-Konto ein",
        "form_ensure_paypal_placeholder": "Bitte bestätigen Sie Ihr PayPal-Konto",
        "form_paypal_name_placeholder": "Bitte geben Sie Ihren PayPal-Namen ein"
    },
    // thanks-all
    thanksAll: {
        doneTitle: 'Alles erledigt! 🎉', doneDescription: 'Ihr Screenshot ist eingegangen! Ihre Geschenkkartenanfrage wird jetzt bearbeitet.',
        request: 'Geschenkkartenanfrage', processing: 'In Bearbeitung', deliveryPrefix: 'Voraussichtliche Zustellung:', deliveryTime: '1-2 Werktage', deliverySuffix: 'per E-Mail.',
        rewardTitle: 'Ihre Prämie', rewardDescription: 'Eine digitale Geschenkkarte im Wert von 20 $ wird an Ihre E-Mail-Adresse gesendet.',
        verifyStep: 'Wir prüfen Ihren Screenshot innerhalb von 1-2 Werktagen.', approvedStep: 'Nach der Freigabe wird Ihre Geschenkkarte per E-Mail an Sie gesendet.', spamStep: 'Bitte prüfen Sie auch Ihren Spam-/Junk-Ordner.', supportText: 'Fragen? Kontaktieren Sie unser Support-Team unter',
        "title": "Dankbar für Ihren Beitrag!",
        // title_desc1: 'Vielen Dank für Ihre Teilnahme an unserer Produktumfrage!',
        // title_desc2: 'projector survey!',
        text: `Ihre wertvolle Meinung wird uns helfen, die Produktqualität zu verbessern. 
Wenn Sie während des Gebrauchs Fragen haben, können Sie uns gerne kontaktieren.`
    },
    // thanks
    thanks: {
        "title": "Herzlichen Glückwunsch!",
        title_desc1: `Ihre Garantie ist aktiviert!
Vielen Dank für Ihre Zeit.`,
        title_default_paypal_desc1: `Ihre Garantie ist aktiviert!
Vielen Dank für Ihre Zeit. Ihre Belohnung wird innerhalb von 24 bis 72 Stunden ausgestellt.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
//  现在还差 跳转到亚马逊， 上传亚马逊评论图片，邮件页面
